/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconChat from 'DesignSystem/Svgs/TysiaIconChat/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Contact/Content/Emails/Content/Email/PreferredIcon/Content"
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaIconChat
  viewPath={`${viewPath}/TysiaIconChat`}
 width={16}
 height={16}
 fill={dtColorsNeutral600}
/>
{children}
</React.Fragment>)
}